<template>
    <div class="c-a-file-upload" :class="{'c-a-file-upload--invalid' : invalid}">
        <p class="c-a-file-upload__title">{{label}} Max({{maxSize}} Mb)</p>
        <label class="c-a-file-upload__button" :for="`file-${id}`">
            <icon :icon="'file_upload'"></icon>
            <span>Lägg till fil(er) <span v-if="required"> *</span></span>
            <input ref="files" class="c-a-file-upload__input" :id="`file-${id}`" type="file" name="attachment"
                @change="addFiles"
                accept="image/png, image/jpeg, image/gif, application/pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx, text/plain"
                multiple/>
        </label>
        <div class="c-a-file-upload__files" v-if="files.length > 0">
            <p class="c-a-file-upload__heading fileSize" :class="{'invalid' : invalid}">Total Storlek: {{size}} Mb / {{maxSize}} Mb</p>
            <p class="c-a-file-upload__heading">Filer som kommer laddas upp:</p>
            <div v-for="(file, i) in files" :key="`file-${i}`" class="c-a-file-upload__file">
                <icon :icon="getIconName(file.type)"></icon>
                <span class="c-a-file-upload__text"> {{file.name}}</span>
                <atom-button class="c-a-file-upload__delete c-a-button--theme-alert c-a-button--small c-a-button--icon-only" :icon="'close'" @buttonClicked="removeFile(...[i])"  ></atom-button>
            </div>
        </div>
    </div>
</template>

<script>
    import Icon from '../AtomIcon.vue';
    import AtomButton from '../AtomButton.vue';

    export default {
        components:{
            Icon,
            AtomButton
        },
        props:{
            id: Number,
            label: String,
            invalid: Boolean,
            required: Boolean
        },
        data(){
            return {
                files: [],
                maxSize: 10
            };
        },
        computed: {
            size: function () {
               let count = 0;
                this.files.forEach(file => {
                    count += file.size
                });
                return Math.round((count / 1000000) * 100) / 100
            },
            validSize: function () {
                return this.size < this.maxSize;
            }
        },
        methods: {
            updated(){
                this.$emit('updateData', { files: this.files, validSize: this.validSize, Id: this.id });
            },
            addFiles(e){
                let uploadedFiles = this.$refs.files.files;

                for( var i = 0; i < uploadedFiles.length; i++ ){
                    this.files.push( uploadedFiles[i] );
                }

                this.updated();
            },
            removeFile(i) {
                if(!this.files[i]) return;

                this.files.splice(i, 1);
                this.updated();
            },
            getIconName(type) {
                let arr = type.split('/');
                
                if (arr[0] === 'image') {
                    return 'file-image'
                }
                else if (arr[1] === 'pdf') {
                    return 'file-pdf'
                }
                else if (arr[1] === 'zip') {
                    return 'file-archive'
                }
                else if (arr[0] === 'text' || arr[0] === 'application') {
                    return 'file-alt'
                }
                else {
                    return 'file'
                }
            }
        }
    }
</script>
<style  scoped>
    .fileSize {
        float:right
    }
    .invalid {
        color: #e60000;
    }
</style>


// WEBPACK FOOTER //
// src/views/components/atoms/request-form/AtomFileUploadRequestForm.vue